import React from "react";
import { useSearchParams } from "react-router-dom";
import { PostApiMethod } from "../../core/services/apiService";
import { setHideNavBar } from "../../core/redux/authSlice";
import { useAppDispatch } from "../../core/redux/hooks";
import { DtoHandOffVideocallSettingsData } from "../../core/dto/dashboard.dto";
import VideoRoom from "./VideoRoom";
import { removeNotification, loggerHelper } from "../../core/services/sharedService";
import AppModal from "../AppModal/AppModal";
import ZoomVideoRoom from "./ZoomVideoRoom";
import { checkAbilityToUseZOOM } from "../../core/services/sharedService";

const VideoCallHandOffRoom = () => {
    const logger = React.useCallback((message: String, details: any) => { loggerHelper(message, details); }, []);
    const [searchParams] = useSearchParams();
    const roomId = searchParams?.get("id")?.replaceAll(" ", "+");
    logger(`Handoff videoRoom video searchParams-`, { "roomId": roomId });
    const [isValidKioskUser, setIsValidKioskUser] = React.useState<boolean>(false);
    const [showPopUp, setShowPopUp] = React.useState(false);
    const dispatch = useAppDispatch();
    const [handOffVideocallInfo, setHandOffVideocallInfo] = React.useState<{
        access_token: string | null, agent_id: string, location: string, notification_id: string, room_name: string, room_sid: string
    }>(
        {
            access_token: "",
            agent_id: "",
            location: "",
            notification_id: "",
            room_name: "",
            room_sid: ""
        }
    );
    const terminateVideoCallRef = React.useRef<Function>(null);

    const [greetingsText, setGreetingsText] = React.useState("");

    const [CustomerLogo, setCustomerLogo] = React.useState<string>("");

    const validateRoom = React.useCallback(() => {
        if (roomId) {
            setIsValidKioskUser(true);
            setGreetingsText("Welcome To RCM! Please wait until our agent connects with you.");
        } else {
            setIsValidKioskUser(false);
        }
    }, [roomId]);

    const getKioskLocationInfo = async () => {
        logger(`Handoff videoRoom video getKioskLocationInfo-`, { id: roomId });
        await PostApiMethod('tenant/callHandOff/get-access-token', { id: roomId }).then((res) => {
            logger(`Handoff videoRoom video getKioskLocationInfo response-`, res);
            setHandOffVideocallInfo((prevState: any) => ({
                ...prevState,
                access_token: res.data.data.access_token,
                agent_id: res.data.data.agent_id,
                location: res.data.data.location,
                notification_id: res.data.data.notification_id,
                room_name: res.data.data.room_name,
                room_sid: res.data.data.room_sid,
            }));

        }).catch((err) => {
            console.log(err, 'handOfferr');
            setCustomerLogo(err.response.data?.data?.logo);
            setGreetingsText("The call has ended or the link has expired");
            logger(`Handoff videoRoom video getKioskLocationInfo error-`, err);
        })
    }

    React.useEffect(() => {
        dispatch(setHideNavBar(true));
        validateRoom();
        getKioskLocationInfo();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [validateRoom]);

    const terminateHandOffCall = (showModal: boolean, isEndedByHost: boolean = false, endVideoRequest: boolean = true) => {
        logger(`Handoff videoRoom video terminateHandOffCall-`, { "showModal": showModal, "endVideoRequest": endVideoRequest });
        if (showModal) {
            setShowPopUp(true);
        } else {
            !checkAbilityToUseZOOM() && setHandOffVideocallInfo((prevState: any) => ({ ...prevState, access_token: null }));
            removeNotification(handOffVideocallInfo?.notification_id);
            setGreetingsText("Thank you for contacting us.");
            if (terminateVideoCallRef && terminateVideoCallRef.current) {
                terminateVideoCallRef.current();
            }
            if (endVideoRequest) {
                let body: any = {
                    room_sid: handOffVideocallInfo?.room_sid,
                    agent_id: handOffVideocallInfo?.agent_id
                };
                if (handOffVideocallInfo?.notification_id)
                    body['notification_id'] = handOffVideocallInfo.notification_id;
                if (handOffVideocallInfo?.location)
                    body['location_id'] = handOffVideocallInfo.location
                logger(`Handoff videoRoom video terminateHandOffCall body-`, body);
                showPopUp && PostApiMethod('tenant/callHandOff/call-hand-off-end-call', body)
                    .then((res: any) => {
                        setHandOffVideocallInfo((prevState: any) => ({ ...prevState, access_token: null }));
                        logger(`Handoff videoRoom video terminateHandOffCall response-`, res);
                        console.log(res);
                    }).catch((err) => {
                        console.log(err);
                        setHandOffVideocallInfo((prevState: any) => ({ ...prevState, access_token: null }));
                        logger(`Handoff videoRoom video terminateHandOffCall error-`, err);
                    })

                isEndedByHost && setHandOffVideocallInfo((prevState: any) => ({ ...prevState, access_token: null }));
            }
        }
    }

    return (
        <>
            {/* <div className="col-12 pb-2 kioskVideoSection"> */}
            <div className="text-center d-flex align-items-center justify-content-center" style={{ height: '100vh' }}>
                {
                    showPopUp &&
                    (
                        <AppModal
                            title={"End call?"}
                            bodyText={"Are you sure you want to end the call?"}
                            primaryButtonLabel={"Yes"}
                            secondaryButtonLabel={"No"}
                            primaryButtonEventEmitter={() => { terminateHandOffCall(false); setShowPopUp(false) }
                            }
                            secondaryButtonEventEmitter={() => setShowPopUp(false)}
                        />
                    )
                }

                {(isValidKioskUser && handOffVideocallInfo.access_token) ?

                    checkAbilityToUseZOOM() ?
                        <ZoomVideoRoom
                            setLocalParticipantInfo={
                                () => { }
                            }
                            twilioToken={handOffVideocallInfo.access_token}
                            roomName={handOffVideocallInfo.room_name}
                            userName={'callHandOff_tenant_user'}
                            terminateVideoCallRef={terminateVideoCallRef}
                            terminateVideoCall={() => { }}
                            locationId={handOffVideocallInfo.location!}
                            notificationId={handOffVideocallInfo.notification_id!}
                            agentId={handOffVideocallInfo.agent_id!}
                            isHandOffRoom={true}
                            terminateHandOffCall={terminateHandOffCall}
                            sessionName={handOffVideocallInfo.room_name}
                        />
                        :
                        <VideoRoom
                            roomName={handOffVideocallInfo.room_name}
                            roomSid={handOffVideocallInfo.room_sid}
                            agentId={handOffVideocallInfo.agent_id!}
                            twilioToken={handOffVideocallInfo.access_token}
                            locationId={handOffVideocallInfo.location}
                            notificationId={handOffVideocallInfo.notification_id}
                            isKiosk={false}
                            setLocalParticipantInfo={() => { }}
                            terminateVideoCall={() => { }}
                            isHandOffRoom={true}
                            terminateHandOffCall={terminateHandOffCall}
                            terminateVideoCallRef={terminateVideoCallRef}
                            addParticipantVideoCall={() => { }}
                        />
                    : (
                        <div className={CustomerLogo ? "text-center pt-5 tenant-room-fixed-height d-block align-items-center justify-content-center" : "text-center app-Fixed-height d-flex align-items-center justify-content-center"}>
                            {
                                CustomerLogo &&
                                <div className="Customerlogo">
                                    <img
                                        src={CustomerLogo}
                                        className="vrm_large_logo"
                                        alt="Logo"
                                    />
                                </div>
                            }
                            <div className="pt-5">
                                {greetingsText}
                            </div>
                        </div>
                    )}
            </div>
        </>
    )
}

export default VideoCallHandOffRoom;